export default {
    computed: {
		selectMap() {
			return this.valueMap(this.response)
		}
	}
}
